import FamilyIconBlack from '../images/logo-brand-black.png'

export const DELETED_USER = () => ({
    img: FamilyIconBlack,
    id: Date.now() * Math.random(),
    firstName: "Deleted User",
    lastName: "",
    isNull: true
})